<template>
  <div>

    <div class="title-button">

      <h1>Brochure Requests</h1>

      <div>
        <button class="button" v-on:click="processRequests">Process new requests</button>
        <button class="button" v-on:click="batchModalVisible = true">Download by Batch</button>
        <button class="button button--secondary" @click="showBrochureRequestModal = true ">Export</button>
      </div>

    </div>

    <div class="box">

      <div class="d-flex justify-content-between">

        <form @submit.stop.prevent="doSearch" class="box__header form--inline">
          <v-select
              :options="brochures"
              label="brochure_name"
              placeholder="Search by brochure."
              id="search_by_brochure"
              index="id"
              v-model="quickSearch"
            />
            &nbsp;&nbsp;
          <input v-model="customerSearch" type="search" placeholder="Search by customer.">
          <input v-model="batchIdSearch" type="search" placeholder="Search by batch ID.">
          <dateTimePicker
            class="ms-2"
            no-label
            label="Requested From"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            :only-date="true"
            button-color="#ec391e"
            color="#ec391e"
            style="border: 1px solid #DFE5F9"
            v-model="brochureRequestedFrom"
          />
          <dateTimePicker
            class="ms-2"
            no-label
            label="Requested To"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            :only-date="true"
            button-color="#ec391e"
            color="#ec391e"
            style="border: 1px solid #DFE5F9"
            v-model="brochureRequestedTo"
          />
          <button class="button button--large ms-2" type="submit"><span>Search</span></button>
        </form>

        <div class="box__header">
          <label for="checkbox">Include sent brochure</label>
          <label class="switch d-block">
            <input v-model="includeSendBrochures" @change="doSearch" id="checkbox" type="checkbox"/>
            <span class="switch__slider"></span>
          </label>
        </div>

      </div>

      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        :select-checkbox="1"
        @viewCustomer="viewCustomer"
        @edit="doAlertEdit"
        :key="tableKey"
        >
      </vdtnet-table>

    </div><!-- box -->

    <!-- Brochure Request Export Modal -->
    <div class="modal" v-if="showBrochureRequestModal">
     <h1>Export With Select Filters</h1>
      <div class="my-4">
        <form class="form form--inline" @submit.stop.prevent="filterBrochureRequest('list')">

          <dateTimePicker
            class="w-50"
            no-label
            label="Requested From"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            :only-date="true"
            button-color="#ec391e"
            color="#ec391e"
            style="border: 1px solid #DFE5F9"
            v-model="exportFilter.brochureRequestedFrom"
          />

          <dateTimePicker
            class="w-50"
            no-label
            label="Requested To"
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            :only-date="true"
            button-color="#ec391e"
            color="#ec391e"
            style="border: 1px solid #DFE5F9"
            v-model="exportFilter.brochureRequestedTo"
          />
          <button class="button button--large ms-2" type="submit"><span>Filter Brochure</span></button>
        </form>
      </div>
      <div class="box">
        <table class="table" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th>Brochure</th>
              <th>Customer</th>
              <th>Brochure Requester</th>
              <th>Affiliate</th>
              <th>Requested at:</th>
              <th>Batch ID</th>
              <th>Sent</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(filteredBrochure, index) in filteredBrochureRequest" :key="index">
              <td>{{ filteredBrochure.brochures_names }}</td>
              <td v-if="filteredBrochure.customer">{{ filteredBrochure.customer.first_name }} {{ filteredBrochure.customer.last_name }}</td>
              <td v-else>-</td>
              <td v-if="filteredBrochure.brochure_requester">{{ filteredBrochure.brochure_requester.first_name }} {{ filteredBrochure.brochure_requester.last_name }}</td>
              <td v-else>-</td>
              <td>{{ filteredBrochure.brochure_requester && filteredBrochure.brochure_requester.affiliate ? filteredBrochure.brochure_requester.affiliate.name : '-'}}</td>
              <td>{{ filteredBrochure.created_at|dateFilter }}</td>
              <td>{{ filteredBrochure.batch_id }}</td>
              <td>{{ filteredBrochure.sent ? '&#10003;' : '-'}}</td>
            </tr>
          </tbody>
        </table>
        <div class="text-end m-4">
          <button v-if="filteredBrochureRequest.length > 0" type="button" class="button" @click="filterBrochureRequest('export')"><span>Export CSV</span></button>
        </div>
      </div>
      <button type="button" class="icon icon--unlink" v-on:click="showBrochureRequestModal = false">Close</button>
    </div>

    <!-- Download By Batch ID Modal -->
    <div class="modal-sm" v-if="batchModalVisible == true">
      <div class="modal__header">
        <h1>Download By Batch ID</h1>
      </div>
      <div class="modal__body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Batch Id</label>
              <input type="text"
                class="form-control" v-model="selectedBatchId"  aria-describedby="helpId" placeholder="Batch Id">
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
            <button class="button mt-1" @click="processRequestsByBatch"><span> Download </span></button>
          </div>
        </div>
      </div>
      <button type="button" class="icon icon--unlink" v-on:click="batchModalVisible = false">Close</button>
    </div>
    <div class="modal__bg" v-if="batchModalVisible == true"></div>
    <!-- Download By Batch ID Modal -->
  </div>
</template>

<script>
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'
import moment from 'moment'
import { mapGetters } from 'vuex'
import axios from 'axios';

export default {
  name: 'brochure-requests',
  components: {
    VdtnetTable
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
  },
  filters: {
    dateFilter: function (date) {
      return moment(date).format('DD/MM/YYYY hh:mm A');
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'brochures/requests/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: false,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
        pageLength: 25,
        select: {
          style: 'multi'
        }
      },
      fields: {
        brochures_names: {
          searchable: false,
          label: 'Brochure',
          render: (data) => {
            if(data !== null) {
              return `${data}`
            } else {
              return '-'
            }
          }
        },
        customer: {
          searchable: false,
          label: 'Customer',
          render: (data) => {
            if(data !== null) {
              return `<a href="/brochure-requests/edit/${ data.id }" data-action="viewCustomer">${ data.first_name } ${ data.last_name }</a>`
            } else {
              return '-'
            }
          }
        },
        brochure_requester: {
          searchable: false,
          label: 'Requester',
          render: (data) => {
            if(data !== null) {
              return `${ data.first_name } ${ data.last_name }`
            } else {
              return '-'
            }
          }
        },
        created_at: {
          searchable: false,
          label: 'Requested at:',
          render: (data) => {
            return (data !== null ? moment(data).format('DD/MM/YYYY<br/>hh:mm A') : '–')
          }
        },
        batch_id: {
          searchable: false,
          label: 'Batch ID',
          render: (data) => {
            if(data !== null) {
              return `${ data }`
            } else {
              return '-'
            }
          }
        },
        sent: {
          searchable: false,
          label: 'Sent?',
          render: (data) => {
            if(data == 0) {
              return ''
            } else {
              return '&#10003;'
            }
          }
        },
        edit: {
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="/affiliates/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
      },
      quickSearch: '',
      customerSearch: '',
      batchIdSearch: '',
      includeSendBrochures: false,
      tableKey: 0, // Key attribute to force re-render of the table,
      brochureRequestedFrom: '',
      brochureRequestedTo: '',
      showBrochureRequestModal: false,
      exportFilter: {
        brochureRequestedFrom: '',
        brochureRequestedTo: '',
      },
      filteredBrochureRequest: [],
      brochures: [],
      selectedBatchId: null,
      batchModalVisible: false,
    }
  },
  methods: {
    doSearch() {
      const ajaxUrl = this.$api + 'brochures/requests/table'

      const queryString = new URLSearchParams();
      if(this.quickSearch) {
        queryString.set('brochure_name', this.quickSearch);
      }

      if(this.customerSearch){
        queryString.set('customer_name', this.customerSearch);
      }

      if(this.batchIdSearch){
        queryString.set('batch_id', this.batchIdSearch);
      }

      if(this.includeSendBrochures){
        queryString.set('include_send_brochures', this.includeSendBrochures);
      }

      if(this.brochureRequestedFrom){
        queryString.set('brochure_requested_from', this.brochureRequestedFrom);
      }

      if(this.brochureRequestedTo){
        queryString.set('brochure_requested_to', this.brochureRequestedTo);
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;
    },
    viewCustomer(data) {
      this.$router.push({ name: 'customer-edit', params: { id: data.customer_id }})
    },
    processRequests() {
      this.$store.dispatch('setLoadStatus')
      console.log('processing');
      fetch(this.$api + 'brochures/requests/process', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((res) => {
        if(res.status === 200) {
          this.$store.dispatch('setLoadStatus')
          let filename = 'cover-letters-' + new Date().toISOString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

          // // Extract the filename from the Content-Disposition header
          // const contentDispositionHeader = res.headers.get('Content-Disposition');
          // const filenameMatch = contentDispositionHeader.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);

          // if (filenameMatch && filenameMatch[1]) {
          //   filename = filenameMatch[1].replace(/['"]/g, ''); // Remove surrounding quotes if any
          //   console.log('Filename from API response:', filename);
          // }
          res.blob().then(response => {
            const _url = window.URL.createObjectURL(response)
            const link = document.createElement('a')
            link.href = _url
            link.setAttribute('download', `${filename}.zip`)
            document.body.appendChild(link)
            link.click();
            this.$notify({
              type: 'success',
              title: 'File downloaded'
            });
            this.doSearch();
          })
        }else {
          this.$store.dispatch('setLoadStatus')
          Promise.race([res.json()])
          .then(response => {
            if(response.message) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            } else {
              this.$notify({
                type: 'error',
                title: response.error
              });
            }
          })
        }
      })
      // .then(res => res.json())
      // .then(response => {
      //   console.log(response);
      //   this.$store.dispatch('setLoadStatus')
      // })
    },
    processRequestsByBatch() {
      
      if (!this.selectedBatchId) {
        this.$notify({
          type: 'error',
          title: 'Please enter a valid Batch ID'
        });
        return;
      }

      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'brochures/process-by-batch', {
        method: 'POST',
        body: JSON.stringify({
          batch_id: this.selectedBatchId
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((res) => {
        if(res.status === 200) {
          this.$store.dispatch('setLoadStatus')
          let filename = 'cover-letters-' + this.selectedBatchId;

          res.blob().then(response => {
            const _url = window.URL.createObjectURL(response)
            const link = document.createElement('a')
            link.href = _url
            link.setAttribute('download', `${filename}.zip`)
            document.body.appendChild(link)
            link.click();
            this.$notify({
              type: 'success',
              title: 'File downloaded'
            });
            this.doSearch();
          })
        }else {
          this.$store.dispatch('setLoadStatus')
          Promise.race([res.json()])
          .then(response => {
            if(response.message) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            } else {
              this.$notify({
                type: 'error',
                title: response.error
              });
            }
          })
        }
      })
      // .then(res => res.json())
      // .then(response => {
      //   console.log(response);
      //   this.$store.dispatch('setLoadStatus')
      // })
    },
    filterBrochureRequest(type) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + `brochures/requests/filter?brochure_requested_from=${this.exportFilter.brochureRequestedFrom}&brochure_requested_to=${this.exportFilter.brochureRequestedTo}&type=${type}`, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((res) => {
        if(res.status === 200 && type == 'export') {
          this.$store.dispatch('setLoadStatus')
          res.blob().then(response => {
            const _url = window.URL.createObjectURL(response)
            const link = document.createElement('a')
            link.href = _url
            link.setAttribute('download', 'brochure-request.xlsx')
            document.body.appendChild(link)
            link.click();
            this.showBrochureRequestModal = false;
          })
        } else {
          this.$store.dispatch('setLoadStatus')
          Promise.race([res.json()])
          .then(response => {
            if(response.success) {
              this.filteredBrochureRequest = response.data;
              this.$notify({
                type: 'success',
                title: response.message
              });
            } else if (response.errors) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            } else {
              this.$notify({
                type: 'error',
                title: response.error
              });
            }
          })
        }
      })
    },
    doAlertEdit(data) {
      this.$router.push({ name: 'brochure-request-edit', params: { id: data.id }})
    },
    getBrochures() {
      axios
        .get(this.$api + "brochure-list?type=active")
        .then((res) => res.data)
        .then((response) => {
          this.brochures = response.data;
          if (this.brochures.length > 0) {
            this.brochures = this.brochures.slice().sort((a, b) => {
              return a.brochure_name.localeCompare(b.brochure_name);
            });
          }
        });
    },
  },
  mounted() {
    this.getBrochures()
  }
}

</script>
